<template>
	<NuxtLink
		:to="`/quote/${symbol?.toUpperCase() || ''}/`"
		:class="[
			'inline-flex items-center rounded-full px-3 py-1 text-sm font-semibold border',
			{
				'border-slate-200 bg-slate-100/[.25] hover:bg-slate-100/[.5]':
					appearence !== 'clear',
				'border-white bg-[#ffffff]/[.10] hover:bg-[#ffffff]/[.20]':
					appearence === 'clear'
			}
		]"
	>
		<span
			:class="
				(['font-bold mr-1'], appearence === 'clear' ? 'text-white' : 'text-black')
			"
		>
			{{ symbol }}
		</span>
		<span
			:class="[
				'flex items-center font-medium',
				isNegative ? 'text-red-500' : 'text-success'
			]"
		>
			<svg
				class="w-3 h-3 mr-0.5"
				fill="none"
				stroke="currentColor"
				stroke-width="2"
				viewBox="0 0 16 16"
			>
				<path
					v-if="!isNegative"
					stroke-linecap="round"
					stroke-linejoin="round"
					d="M8 12V4m0 0L4 8m4-4l4 4"
				/>
				<path
					v-else
					stroke-linecap="round"
					stroke-linejoin="round"
					d="M8 4v8m0 0l4-4m-4 4L4 8"
				/>
			</svg>
			{{ change }}
		</span>
	</NuxtLink>
</template>
<script setup>
import { computed } from "vue";

const props = defineProps({
	symbol: {
		type: String,
		required: true
	},
	change: {
		type: String,
		default: ""
	},
	appearence: {
		type: String,
		default: ""
	},
	highlight: {
		type: Boolean,
		default: false
	}
});

// Check if the change value is negative
const isNegative = computed(() => {
	const numericValue = parseFloat(props.change.replace("%", ""));
	return numericValue < 0;
});
</script>
